export default function Careers() {
  return (
    <section id="careers" className="py-20 bg-gradient-to-br from-[#f8f9fa] to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Join Our Winning Team
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Build a rewarding career helping people get the insurance settlements they deserve
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" style={{ width: '100%', height: '500px' }}>
              <img 
                src="https://public.readdy.ai/ai/img_res/4c482936f834f3b9d9fe367f30fed7ae.jpg"
                alt="Join our professional team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#FF6B35] text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <div className="text-3xl font-bold mb-2">Training Provided</div>
              <p className="text-sm text-white/90">
                We invest in your success with comprehensive training and ongoing support
              </p>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-4">
                <i className="ri-graduation-cap-line text-[#FF6B35] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-3">Comprehensive Training</h3>
              <p className="text-gray-600 leading-relaxed">
                No experience required! We provide complete training in insurance claims, public adjusting, and client advocacy. Learn from industry experts and grow your expertise.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-4">
                <i className="ri-team-line text-[#FF6B35] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-3">Supportive Environment</h3>
              <p className="text-gray-600 leading-relaxed">
                Join a team that values collaboration, integrity, and making a real difference in people's lives. We celebrate wins together and support each other's growth.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="w-14 h-14 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-4">
                <i className="ri-trophy-line text-[#FF6B35] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-3">Career Growth</h3>
              <p className="text-gray-600 leading-relaxed">
                Build a meaningful career with competitive compensation, advancement opportunities, and the satisfaction of helping clients achieve fair settlements.
              </p>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="mt-16 bg-gradient-to-r from-[#1e3a5f] to-[#2d5a8f] rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">Ready to Start Your Career?</h3>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Take the first step towards a rewarding career. Contact us today to learn more about opportunities with Claim It Assist.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <a 
              href="tel:9089222919"
              className="flex items-center space-x-3 bg-white text-[#1e3a5f] px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-2xl"></i>
              </div>
              <span>(908) 922-2919</span>
            </a>
            
            <a 
              href="mailto:info@claimitassist.com?subject=Career Opportunity Inquiry"
              className="flex items-center space-x-3 bg-[#FF6B35] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#ff5722] transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-mail-line text-2xl"></i>
              </div>
              <span>Email Your Resume</span>
            </a>
          </div>

          <p className="text-white/80 text-sm mt-6">
            Send your resume to: <strong className="text-white">info@claimitassist.com</strong>
          </p>
        </div>
      </div>
    </section>
  );
}